import { Box } from "@mui/material"
import React, { useCallback, useContext } from "react"
import {
  BOTTOM_NAVIGATION_HEIGHT,
  CustomBottomNavigation,
} from "../../../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import {
  BSInputParkingForm,
  bsInputParkingFormToUpdateDto,
  bsParkingDtoToForm,
  IBSInputParkingForm,
} from "../../../../tabs/BSBuildingTabs/BSBuildingParkingTab/components/BSInputParkingForm"
import { useForm } from "../../../../../../../../../core/hooks/form/use-form"
import { required } from "../../../../../../../../../core/hooks/form/validation"
import { BSVariantControlPanelContext } from "../../../../components/BSVariantControlPanelContext"
import { CalculStatusEnum } from "../../../../../../../../../core/enum/calculStatusEnum"
import { SuccessContext } from "../../../../../../../../../components/layout/success-snackbar"
import { BSInputContext } from "../../../../../../../../../core/context/beem-shot/BSInput/BSInputContext"
import { BSBuildingContext } from "../../../components/context/BSBuildingContext"

interface IProps {
  isUpdating: boolean
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>
}

export function BSParkingBimContainer({ isUpdating, setIsUpdating }: Readonly<IProps>): React.JSX.Element {
  const openSuccessSnackbar = useContext(SuccessContext)

  const { bsInput, updateBSInputParking } = useContext(BSInputContext)
  const { controlPanelRefWidth } = useContext(BSVariantControlPanelContext)
  const { updateCalculStatusState } = useContext(BSBuildingContext)

  const submit: (form: IBSInputParkingForm) => Promise<any> = useCallback(
    (form) => {
      if (bsInput) {
        return updateBSInputParking(bsInputParkingFormToUpdateDto(form, bsInput.id)).then(() => {
          updateCalculStatusState(CalculStatusEnum.WAITING_FOR_CONFIGURATION)
          setIsUpdating(false)
          openSuccessSnackbar("Les informations de l'estimation ont été mises à jour.")
        })
      }
      return Promise.resolve()
    },
    [bsInput, openSuccessSnackbar, setIsUpdating, updateBSInputParking, updateCalculStatusState]
  )

  const { form, errors, handleChange, handleSubmit, isSubmitting } = useForm(
    bsInput,
    bsParkingDtoToForm,
    [required("typeParking"), required("nombrePlaceParking")],
    submit,
    () => setIsUpdating(true)
  )

  return (
    <Box
      component="form"
      id="update-bs-building-parking"
      onSubmit={handleSubmit}
      height={isUpdating ? `calc(100% - ${BOTTOM_NAVIGATION_HEIGHT} -  2vh)` : "100%"}
      px={5}
      pb={2}
      sx={{ overflow: "auto" }}>
      <BSInputParkingForm title="Stationnement" form={form} handleChange={handleChange} errors={errors} />

      {isUpdating && (
        <CustomBottomNavigation
          actionLabel="Enregistrer"
          formId="update-bs-building-parking"
          isSubmitting={isSubmitting}
          additionalLeftPadding={controlPanelRefWidth}
        />
      )}
    </Box>
  )
}
